export function Logo({ variant = "black", type = "wordmark", className = "", height = 34 }) {
  const map = {
    wordmark: {
      black: "/brand/growing-black.png",
      white: "/brand/growing-white.png",
      orange: "/brand/growing-orange.png",
    },
    icon: {
      black: "/brand/g-icon-black.png",
      white: "/brand/g-icon-white.png",
      orange: "/brand/g-icon-orange.png",
      pink: "/brand/g-icon-pink.png",
    },
  };
  const src = (map[type] && map[type][variant]) || map.wordmark.black;
  return (
    <img
      src={src}
      alt="Growing"
      style={{ height }}
      className={`w-auto object-contain ${className}`}
      data-testid="brand-logo"
    />
  );
}
